import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './OverviewTab.css';

/**
 * Terminals Tab Component
 * Displays Terminal table for Merchant Admins with Reports page styling
 * Shows terminal details including status, type, and last activity
 */
export function TerminalsTab({ terminals, accountId }) {
  const [searchTerm, setSearchTerm] = useState('');

  function formatDate(dateString) {
    if (!dateString) return 'Never';
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(new Date(dateString));
  }

  const filteredTerminals = (terminals || []).filter(terminal => {
    if (!searchTerm) return true;
    const lowerSearch = searchTerm.toLowerCase();
    const terminalName = (terminal.name || terminal.terminal_id || '').toLowerCase();
    const terminalId = String(terminal.id || terminal.terminal_id || '');
    return terminalName.includes(lowerSearch) || terminalId.includes(lowerSearch);
  });

  // Status Chip Component
  function StatusChip({ active }) {
    return (
      <span className={`status-chip ${active ? 'positive' : 'neutral'}`}>
        {active ? 'Active' : 'Inactive'}
      </span>
    );
  }

  return (
    <div className="fi-table-section">
      <div className="fi-table-header">
        <h3 className="fi-table-title">Terminals</h3>
        <div className="fi-search-container">
          <FontAwesomeIcon icon={['fal', 'search']} className="fi-search-icon" />
          <input
            type="text"
            className="fi-search-input"
            placeholder="Search terminals..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      <div className="fi-table-container">
        <table className="fi-table">
          <thead>
            <tr>
              <th className="col-name">Terminal Name</th>
              <th className="col-status text-center">Status</th>
              <th className="col-type">Type</th>
              <th className="col-location">Location</th>
              <th className="col-last-active text-right">Last Active</th>
            </tr>
          </thead>
          <tbody>
            {filteredTerminals.length === 0 ? (
              <tr>
                <td colSpan={5} className="fi-table-empty">
                  <div className="fi-table-empty-icon">
                    <FontAwesomeIcon icon={['fal', 'tablet-alt']} />
                  </div>
                  {searchTerm ? 'No terminals match your search' : 'No terminals configured'}
                </td>
              </tr>
            ) : (
              filteredTerminals.map((terminal) => (
                <tr key={terminal.id || terminal.terminal_id}>
                  <td className="col-name">
                    <span className="fi-name-link">
                      {terminal.name || `Terminal ${terminal.terminal_id || terminal.id}`}
                    </span>
                    <div className="fi-id-caption">ID: {terminal.terminal_id || terminal.id}</div>
                  </td>
                  <td className="col-status text-center">
                    <StatusChip active={terminal.is_active} />
                  </td>
                  <td className="col-type">
                    {terminal.terminal_type || terminal.type || 'Standard'}
                  </td>
                  <td className="col-location">
                    {terminal.location || terminal.description || '-'}
                  </td>
                  <td className="col-last-active text-right">
                    {formatDate(terminal.last_active_at || terminal.last_transaction_at)}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {filteredTerminals.length > 0 && (
        <div className="fi-table-footer">
          <span>
            Showing {filteredTerminals.length} of {(terminals || []).length} Terminals
          </span>
        </div>
      )}
    </div>
  );
}
